import { action, observable, runInAction, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { ProductPartForm } from 'modules/product/forms';
import { ProductStore, MultiPackageProductStore } from 'modules/product/stores';
import _ from 'lodash';
import { sourceOfChange } from 'common/constants';

class AddExistingProductModalContentViewStore extends BaseViewStore {
	@observable productOptions = [];
	@observable debouncedProductSearch = null;
	@observable isProductDropdownLoading = false;
	@observable isSaveClicked = false;
	@observable isBackClicked = false;
	@observable tempProductOptions = [];
	@observable pageProduct = 1;
	@observable infiniteSearchPhrase = null;

	addExistingProductForm = new ProductPartForm({
		onSuccess: async () => {
			await this.createProductCombination();
		},
	});

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.productStore = new ProductStore(rootStore);
		this.parentView = this.rootStore.productDetailViewStore;
		this.multiPackageProductStore = new MultiPackageProductStore(rootStore);
		this.excludedIds = componentProps.currentPartsIds;
		this.debouncedProductSearch = _.debounce((searchPhrase, { action }) => {
			this.searchProductAsync(searchPhrase, { action });
		}, 1000);
		this.initialize();
	}

	@action initialize = async () => {
		this.addExistingProductForm.state.options.set({
			validateOnChange: true,
		});
		await this.searchProductAsync('', { action: '' }, true);
	};

	@action.bound clearProductOptions = action => {
		if (action === 'input-change') {
			this.isProductDropdownLoading = true;
			this.productOptions = [];
		}
	};

	@action.bound onProductMenuClose = async () => {
		await this.searchProductAsync('', { action: '' }, true);
	};

	@action.bound searchProductAsync = async (searchPhrase, { action }, isInitialFetch = false) => {
		if (searchPhrase === '') {
			this.pageProduct = 1;
		}
		if (action === 'input-change' || isInitialFetch) {
			this.isProductDropdownLoading = true;
			this.infiniteSearchPhrase = searchPhrase;
			this.pageProduct = 1;
			this.productOptions = [];
			await this.productStore.findProduct({
				page: 1,
				rpp: 15,
				search: searchPhrase || null,
				excludedIds: this.excludedIds,
				searchFields: 'mainSku',
				isMultiproduct: false,
				sellerIds: [this.parentView.product.sellerId],
			});
			this.productOptions = _.map(this.productStore.response.item, product => {
				return {
					value: product.id,
					label: product.mainSku,
					extra: product,
				};
			});
			this.isProductDropdownLoading = false;
		}
	};

	@action.bound
	async handleOnProductMenuScroll() {
		if (this.productOptions.length < this.pageProduct * 15) return;
		this.pageProduct++;
		this.isProductDropdownLoading = true;

		await this.productStore.findProduct({
			page: this.pageProduct,
			search: this.infiniteSearchPhrase,
			rpp: 15,
			excludedIds: this.excludedIds,
			searchFields: 'mainSku',
			isMultiproduct: false,
			sellerIds: [this.parentView.product.sellerId],
		});
		this.tempProductOptions = _.map(this.productStore.response.item, product => {
			return {
				value: product.id,
				label: product.mainSku,
				extra: product,
			};
		});
		if (this.tempProductOptions.length > 0) {
			this.productOptions = this.productOptions.concat(this.tempProductOptions);
			this.tempProductsOptions = [];
		}
		this.isProductDropdownLoading = false;
	}

	@action.bound
	async onMenuClose() {
		this.pageProducts = 1;
		this.productOptions = [];
		this.infiniteSearchPhrase = null;
		await this.searchProductAsync('', { action: '' }, true);
	}

	@action.bound onProductChange = value => {
		this.addExistingProductForm.$('product').value = value;
	};

	@action.bound createProductCombination = async () => {
		this.isSaveClicked = true;
		const { product, quantity } = this.addExistingProductForm.values();

		const multiPackageProduct = {
			parentProductId: this.rootStore.routerStore.routerState.params.id,
			productId: product.value,
			quantity,
		};

		await this.multiPackageProductStore.create(multiPackageProduct, sourceOfChange.createProductCombination);
		this.rootStore.notificationStore.success('PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.PRODUCTPARTADDSUCCESS');
		this.parentView.addExistingProductModal.close();
		this.parentView.initialize();
	};

	@action.bound goBackToProductPartTypeSelection = () => {
		this.isBackClicked = true;
		this.parentView.openAddProductPartModal();
		this.parentView.addExistingProductModal.close();
		this.isBackClicked = false;
	};
}

export default AddExistingProductModalContentViewStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/AddExistingProductModalContentViewStore.js